import { videoEmbedUrl } from "@/lib/api";

export const VideoEmbed = ({ url }) => {
  const src = videoEmbedUrl(url);
  if (!src) {
    return (
      <p className="text-sm text-rose-600" data-testid="video-invalid">
        This video link is not a recognised YouTube or Vimeo URL.
      </p>
    );
  }
  return (
    <div className="relative w-full overflow-hidden rounded-2xl border border-slate-200 bg-slate-900 shadow-sm" style={{ paddingTop: "56.25%" }} data-testid="video-embed">
      <iframe
        src={src}
        title="Tutorial video"
        className="absolute inset-0 w-full h-full"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
    </div>
  );
};
